import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'ramda';
import { reduxForm, formValueSelector } from 'redux-form';

import { FORM_NAMES } from 'constants/forms';
import HeaderSearch from 'components/ui/HeaderSearch';
import { PATIENT_ID } from '../constant';

const selector = formValueSelector(FORM_NAMES.filterReports);

const mapStateToProps = state => ({
  searchField: selector(state, 'type'),
  searchValue: selector(state, 'searchValue'),
  defaultSearchField: PATIENT_ID,
  initialValues: {
    type: PATIENT_ID,
    searchValue: '',
  },
});

export default compose(
  connect(mapStateToProps),
  reduxForm({
    form: FORM_NAMES.filterReports,
  }),
  withTranslation(),
)(HeaderSearch);
